<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <sn-user-search-input @change="onName" class="search-item"></sn-user-search-input>
                
                <el-select v-model="params.status" clearable placeholder="选择报销状态" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-date-picker
                    type="date"
                    placeholder="开始报销日期"
                    v-model="params.timeStart"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止报销日期"
                    v-model="params.timeEnd"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

            </el-row>

            <el-row class="search-row">
                <el-input v-model="params.id" placeholder="报销单号" class="search-item"></el-input>
                <el-input v-model="params.expenses" placeholder="支出单号" class="search-item"></el-input>
                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 135"
            class="finance-expense-table"
        >
            <el-table-column prop="id" label="报销单号" width="200"></el-table-column>
            <el-table-column prop="cost" label="报销金额" width="100">
                <template slot-scope="expend">{{ $tools.parsecost(expend.row.cost, true)}}</template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="120">
                <template slot-scope="expend">
                    <el-tag type="info" v-if="expend.row.status == 'WAIT_REVIEW'">待报销审核</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT'">待操作</el-tag>
                    <el-tag type="success" v-if="expend.row.status == 'WAIT_PAY'">等待打款</el-tag>
                    <el-tag type="success" v-if="expend.row.status == 'PAID'">已打款</el-tag>
                    <el-tag type="swarning" v-if="expend.row.status == 'UNPASS'">未通过</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'INVALID'">废弃</el-tag>
               </template>
            </el-table-column>

            <el-table-column prop="creatorName" label="申请人" width="100"></el-table-column>
            <el-table-column prop="createTime" label="申请日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.createTime)}}</template>
            </el-table-column>

            <el-table-column prop="reviewerName" label="审核人" width="100"></el-table-column>
            <el-table-column prop="reviewTime" label="审核日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.reviewTime)}}</template>
            </el-table-column>

            <el-table-column prop="payerName" label="打款人" width="100"></el-table-column>
            <el-table-column prop="paymentTime" label="打款日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.paymentTime)}}</template>
            </el-table-column>

            <el-table-column prop="expenses" label="关联支出" width="200" :show-overflow-tooltip="true">
                <template slot-scope="expend">
                    <finance-cell-view :datas="expend.row.expenses" type="E"></finance-cell-view>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
            :page-size.sync="params.size"
        ></el-pagination>
    </div>
</template>

<script>
import FinanceCellView from './Finance-cell-view.vue';
import SnUserSearchInput from "../components/SnUserSearchInput.vue";

export default {
    components: {SnUserSearchInput, FinanceCellView },
    data() {
        return {
            params: {
                creator: null,
                status: null,
                timeStart: null,
                timeEnd: null,
                current: null,
                total: null,
            },
            records: [],
            status: [
                { id: "WAIT_REVIEW", name: "待报销审核" },
                { id: "WAIT_PAY", name: "等待打款" },
                { id: "PAID", name: "已打款" },
                { id: "UNPASS", name: "未通过" },
                { id: "INVALID", name: "废弃" }
            ],
        };
    },
    methods: {
        page(current) {
            let _this = this;

            _this.params.current = current;

            _this.$http.post(
                ["finance/expense/account/page", _this.params],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.params.total = data.total;
                    },
                ],
                ".finance-expense-table"
            );
        },
        showAddDialog() {
            this.showDialog = true;
        },
         onName(creator) {
            this.params.creator = creator;
            this.page(1);
        },
    },
    mounted() {
        this.page(1);
    },
};
</script>

<style lang="scss">
</style>